// import React, { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { searched } from '../../features/filterSlice/filterSlice';

// const SearchSide = () => {
//     const dispatch = useDispatch();
//     const { search } = useSelector((state) => state.filter);
//     const [input, setInput] = useState(search);

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         dispatch(searched(input));
//     };

//     return (
//         <div>
//             <div className="container mx-auto p-5">
//                 <div className="flex items-center justify-center">
//                         {/* <div className="relative text-gray-600 focus-within:text-gray-400">
//                             <span className="absolute inset-y-0 left-0 flex items-center pl-2">
//                                 <button type="submit" className="p-1 focus:outline-none focus:shadow-outline">
//                                     <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-6 h-6"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
//                                 </button>
//                             </span>
//                             <input type="search" name="q" className="w-full py-2 text-sm rounded-md pl-10 focus:outline-none focus:bg-white focus:text-gray-900" placeholder="Search..." autoComplete="off"/>
//                         </div> */}
//                         <input className='border' type="text" />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SearchSide;
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { searched } from '../../features/filterSlice/filterSlice';
import debounce from 'lodash.debounce';
import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useGetProductsQuery } from '../../features/api/apiSlice';
import SearchItemLoader from '../ui/loaders/SearchItemLoader';
import { useTranslation } from 'react-i18next';

export default function SearchSide() {
    const { data: products, isLoading, isError } = useGetProductsQuery();
    // const products = useSelector((state) => state.filter.items);
    const inputText = useSelector((state) => state.filter.search);
    
    const dispatch = useDispatch();
    const [value, setValue] = useState('');
    const { t } = useTranslation();

    // debounce
    const debouncedSave = useRef(debounce(nextValue => handleDispatch(nextValue), 500)).current;

    const handleChange = event => {
        const { value: nextValue } = event.target;
        setValue(nextValue);
        debouncedSave(nextValue);
    };

    const handleDispatch = (value) => {
        dispatch(searched(value));
    };


    // open popup functions 
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    let content = null;
    if (isLoading) {
        content = (
            <div>
                <SearchItemLoader/>
                <SearchItemLoader/>
                <SearchItemLoader/>
                <SearchItemLoader/>
                <SearchItemLoader/>
            </div>
        )
    }
    if (!isLoading && isError) {
        content = <h1>{t('utils.error')}</h1>
    }
    if (!isLoading && !isError && products?.length === 0) {
        content = <h1>{t('utils.notFound')}</h1>
    }
    if (!isLoading && !isError && products?.length > 0) {

        content = (
            <div>
                {
                     products.filter(item => item?.name.toLowerCase().includes(inputText.trim().toLowerCase()))
                        .slice(0, 15)
                        .map((item, i) => (
                            <Link key={i} to={`/products/${item._id}`} onClick={handleClose} className="text-link">

                                <div className="text-md font-normal text-gray-600 grid grid-cols-9 content-center justify-center gap-x-2  py-2 border-b">
                                    <div className='md:block hidden'>
                                        <div className='w-full col-span-1 grid justify-center'>
                                            <img className='w-12' src={item.cardImg} alt="" />
                                        </div>
                                    </div>
                                    <div className='md:px-2 px-0 h-full col-span-4 md:mb-0 mb-3'>
                                        <div className='h-full grid content-center'>
                                            <p className=''>{item.name.length > 32 ? (item.name.substring(32, 0) + "..") : item.name}</p>

                                        </div>
                                    </div>
                                    <div className='md:flex flex-none md:pt-3 col-span-4 grid content-center md:space-x-2 space-x-0'>
                                        <div className='w-full flex justify-end gap-x-2'>
                                            <p className='text-redbnd line-through whitespace-nowrap'>{Number(item.price) < Number(item.prvPrice) && (item.prvPrice + ' BDT')}</p>
                                            <p className='whitespace-nowrap'>{item.price} BDT</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))
                }
            </div>
        )
    }

    return (
        <div>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
                Open form dialog
            </Button> */}
            <i onClick={handleClickOpen} className="fa fa-search text-xl text-gray-500 hover:text-bnd-1" aria-hidden="true"></i>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    <div className="flex items-center">
                        <label for="simple-search" className="sr-only">Search</label>
                        <div className="relative w-full">
                            <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                                <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path></svg>
                            </div>
                            {/* <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Email Address"
                        type="email"
                        fullWidth
                        variant="standard"
                    /> */}
                            <input
                                type="text"
                                id="simple-search"
                                className="bg-gray-50 py-3 border-gray-300 focus:outline-none text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder="Search"
                                autoFocus={true}
                                value={value}
                                onChange={handleChange}
                            />
                        </div>
                        <button onClick={handleClose} className="text-md font-poppins w-20 py-3 ml-2 text-sm font-medium bg-gray-100 rounded-lg">
                            {/* <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg> */}
                            <span className="">E S C</span>
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleClose}>Subscribe</Button>
                </DialogActions> */}
            </Dialog>
        </div>
    );
}